import React from 'react'
import { darken, lighten, makeStyles } from '@material-ui/core';
import { Bar, defaults } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { COLORS_PROJECT } from '../../constants';

const {color_nav_letter,color_nav,color_back}= COLORS_PROJECT;
defaults.global.defaultFontColor  = darken(color_back,1);

const options = {
    maintainAspectRatio: false,
    responsive: true,
    title:{
        display:true,
        text:'Rayos por minuto',
        fontSize:20,
        fontColor: darken(color_nav,0.45),
    },
    legend:{
        display: true,
        position:'top',
        labels:{
            fontColor: darken(color_nav_letter,1),
        },
    },
    scales:{
        xAxes: [{
            gridLines:{
                color: color_back,
            }
        }],
        yAxes: [{
            gridLines:{
                color: color_back,
            },
            ticks: {
                beginAtZero: true,
                callback: function(value) {if (value % 1 === 0) {return value;}}
            },
            scaleLabel: {
                display: true,
                labelString: 'Cantidad'
            },
        }],
    },
}

const useStyles = makeStyles((theme) => ({
    sizeChart: {
        width: '100%',
        height: '350px',
        backgroundColor: lighten(color_back, 0.8),//lighten(theme.palette.primary.main,0.5),
    },
}));

export const BarChartAlarmsType = ({dataChart=[] , type=1}) => {
    const classes= useStyles();
    const {colorPoints,nameAlerts} = useSelector(state => state.auth)
    const arrColors = colorPoints.split(",")
    const arrNamesAlerts = nameAlerts.split(",")

    let color;
    let name;

    if(type===1){
         color=arrColors[1]//color_alarm_yellow;
         name = arrNamesAlerts[0];//'Nivel Bajo';
    }else if(type===2){
         color=arrColors[2]//color_alarm_orange;
         name = arrNamesAlerts[1];//'Nivel Medio';
    }else if (type===3) {
         color=arrColors[3]//color_alarm_red;
         name = arrNamesAlerts[2];//'Nivel Alto';
    }

    const dates =  dataChart.map(v=>v.fecha_out).sort()
    const dataAlarms = dataChart.map(v=>v.minute_ct);

    const data = {
        labels: dates,
        datasets:[{
            label: `${name}`,
            backgroundColor: color,
            borderColor: darken(color,0.4),
            borderWidth: 1,
            hoverBackgroundColor: lighten(color,0.1),
            hoverBorderColor: lighten(color,0.4),
            data: dataAlarms,
        }]
    }
    
    return (
        <div className={classes.sizeChart}>
            <Bar data={data} options={options} />
        </div>
    )
}


BarChartAlarmsType.propTypes = {
    dataChart: PropTypes.array,
    type: PropTypes.number.isRequired,
};